<template>
  <div>
    <h1 class="text-6xl m-8">401 - Unauthorized</h1>
  </div>
</template>
